/**
 * Call the PDF export API and trigger download. Used by the "Export premium (PDF Typst)" option.
 */
import { saveAs } from "file-saver";
import type { CVData } from "../types";
import type { GenerateTypstOptions, TypstLayout } from "./cv-to-typst";

export type ExportPdfApiResult =
  | { ok: true }
  | { ok: false; status: number; error: string };

/**
 * POST /api/pdf/export with cvData, layout, options. On success, download as filename.
 * @param filename - e.g. getPrintFilename() + '.pdf'
 */
export async function exportPdfViaApi(
  cvData: CVData,
  layout: TypstLayout,
  options: GenerateTypstOptions,
  filename: string = "CV_Export.pdf"
): Promise<ExportPdfApiResult> {
  const body = { cvData, layout, options, filename };
  const res = await fetch("/api/pdf/export", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const json = await res.json().catch(() => ({}));
    const error = (json && typeof json.error === "string" ? json.error : res.statusText) || "Erreur export PDF";
    return { ok: false, status: res.status, error };
  }

  const blob = await res.blob();
  saveAs(blob, filename);
  return { ok: true };
}
